/* 
  右侧测点列表
  isAscShow:是否显示升降序符号
  isArrow:箭头
  name:测点名称
  full_name:测点全称
  value:测点值
  unit:测点单位
    */
export const MEASUREMENTS_LIST = [
          //pick-up felt
          {
            id:1,
            pos:'top:38px;left:40px',
            equip_id:"739d3670-141f-11f0-8da8-0d1c443f2d5f",
            list:[
              { isAscShow:false, isArrow:null, name:'车速', full_name: "车速", value:'-', unit:'m/min'},
              { isAscShow:false, isArrow:null, name:'纸种克重', full_name: "纸种克重", value:'-', unit:'g/m²'},
              { isAscShow:false, isArrow:null, name:'毛布使用情况', full_name: "毛布使用情况", value:'-', unit:'天'},
              { isAscShow:false, isArrow:null, name:'总脱水量', full_name: "总脱水量", value:'-', unit:'l/min'},
              { isAscShow:false, isArrow:null, name:'真空脱水量', full_name: "真空脱水量", value:'-', unit:'l/min'},
            ],
          },
          {
            id:2,
            pos:'top:210px;left:40px',
            equip_id:"739d3670-141f-11f0-8da8-0d1c443f2d5f",
            list:[
              { isAscShow:false, isArrow:null, name:'Bearing D1 温度', full_name: "电机轴承温度D1", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Bearing D2 温度', full_name: "电机轴承温度D2", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'D1 Vibration 震动', full_name: "透平机震动D1", value:'-', unit:'mm/s'},
              { isAscShow:false, isArrow:null, name:'D2 Vibration 震动', full_name: "透平机震动D2", value:'-', unit:'mm/s'},
              { isAscShow:false, isArrow:null, name:'Stator D1 温度', full_name: "电机定子温度D1", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Stator D2 温度', full_name: "电机定子温度D2", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Volute 温度', full_name: "透平机蜗壳温度", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Turbo 转速', full_name: "透平机转速", value:'-', unit:'rpm'},
              { isAscShow:false, isArrow:null, name:'电流', full_name: "电流", value:'-', unit:'A'},
              { isAscShow:false, isArrow:null, name:'真空度', full_name: "透平机真空度", value:'-', unit:'kpa.g'},
            ],
          },
          //1st press
          {
            id:3,
            pos:'top:265px;left:670px',
            equip_id:"06b8f8e0-1420-11f0-8da8-0d1c443f2d5f",
            list:[
              { isAscShow:false, isArrow:null, name:'车速', full_name: "车速", value:'-', unit:'m/min'},
              { isAscShow:false, isArrow:null, name:'纸种克重', full_name: "纸种克重", value:'-', unit:'g/m²'},
              { isAscShow:false, isArrow:null, name:'毛布使用情况', full_name: "毛布使用情况", value:'-', unit:'天'},
              { isAscShow:false, isArrow:null, name:'总脱水量', full_name: "总脱水量", value:'-', unit:'l/min'},
              { isAscShow:false, isArrow:null, name:'真空脱水量', full_name: "真空脱水量", value:'-', unit:'l/min'},
            ],
          },
          {
            id:4,
            pos:'bottom:38px;left:564px',
            equip_id:"06b8f8e0-1420-11f0-8da8-0d1c443f2d5f",
            list:[
              { isAscShow:false, isArrow:null, name:'Bearing D1 温度', full_name: "电机轴承温度D1", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Bearing D2 温度', full_name: "电机轴承温度D2", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'D1 Vibration 震动', full_name: "透平机震动D1", value:'-', unit:'mm/s'},
              { isAscShow:false, isArrow:null, name:'D2 Vibration 震动', full_name: "透平机震动D2", value:'-', unit:'mm/s'},
              { isAscShow:false, isArrow:null, name:'Stator D1 温度', full_name: "电机定子温度D1", value:'-', unit:'℃'},
            ],
          },
          {
            id:5,
            pos:'bottom:38px;right:320px',
            equip_id:"06b8f8e0-1420-11f0-8da8-0d1c443f2d5f",
            list:[
              { isAscShow:false, isArrow:null, name:'Stator D2 温度', full_name: "电机定子温度D2", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Volute 温度', full_name: "透平机蜗壳温度", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Turbo 转速', full_name: "透平机转速", value:'-', unit:'rpm'},
              { isAscShow:false, isArrow:null, name:'电流', full_name: "电流", value:'-', unit:'A'},
              { isAscShow:false, isArrow:null, name:'真空度', full_name: "透平机真空度", value:'-', unit:'kpa.g'},
            ],
          },
          //3rd press
          {
            id:6,
            pos:'top:38px;left:1000px',
            equip_id:"3a0e4c90-1420-11f0-8da8-0d1c443f2d5f",
            list:[
              { isAscShow:false, isArrow:null, name:'车速', full_name: "车速", value:'-', unit:'m/min'},
              { isAscShow:false, isArrow:null, name:'纸种克重', full_name: "纸种克重", value:'-', unit:'g/m²'},
              { isAscShow:false, isArrow:null, name:'毛布使用情况', full_name: "毛布使用情况", value:'-', unit:'天'},
              { isAscShow:false, isArrow:null, name:'总脱水量', full_name: "总脱水量", value:'-', unit:'l/min'},
              { isAscShow:false, isArrow:null, name:'真空脱水量', full_name: "真空脱水量", value:'-', unit:'l/min'},
            ],
          },
          {
            id:7,
            pos:'top:210px;left:1000px',
            equip_id:"3a0e4c90-1420-11f0-8da8-0d1c443f2d5f",
            list:[
              { isAscShow:false, isArrow:null, name:'Bearing D1 温度', full_name: "电机轴承温度D1", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Bearing D2 温度', full_name: "电机轴承温度D2", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'D1 Vibration 震动', full_name: "透平机震动D1", value:'-', unit:'mm/s'},
              { isAscShow:false, isArrow:null, name:'D2 Vibration 震动', full_name: "透平机震动D2", value:'-', unit:'mm/s'},
              { isAscShow:false, isArrow:null, name:'Stator D1 温度', full_name: "电机定子温度D1", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Stator D2 温度', full_name: "电机定子温度D2", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Volute 温度', full_name: "透平机蜗壳温度", value:'-', unit:'℃'},
              { isAscShow:false, isArrow:null, name:'Turbo 转速', full_name: "透平机转速", value:'-', unit:'rpm'},
              { isAscShow:false, isArrow:null, name:'电流', full_name: "电流", value:'-', unit:'A'},
              { isAscShow:false, isArrow:null, name:'真空度', full_name: "透平机真空度", value:'-', unit:'kpa.g'},
            ],
          },
]


export const MEASUREMENTS_LIST_1 = [
  //pick-up felt
  {
    id:1,
    pos:'top:38px;left:40px',
    equip_id:"7fab1e60-dfde-11f0-b610-85349516fd91",
    list:[
      { isAscShow:false, isArrow:null, name:'车速', full_name: "车速", value:'-', unit:'m/min'},
      { isAscShow:false, isArrow:null, name:'纸种克重', full_name: "纸种克重", value:'-', unit:'g/m²'},
      { isAscShow:false, isArrow:null, name:'毛布使用情况', full_name: "毛布使用情况", value:'-', unit:'天'},
      { isAscShow:false, isArrow:null, name:'总脱水量', full_name: "总脱水量", value:'-', unit:'l/min'},
      { isAscShow:false, isArrow:null, name:'真空脱水量', full_name: "真空脱水量", value:'-', unit:'l/min'},
      { isAscShow:false, isArrow:null, name:'供油温度', full_name: "供油温度", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'供油压力', full_name: "供油压力", value:'-', unit:'Mpa'},
    ],
  },
  {
    id:2,
    pos:'top:210px;left:40px',
    equip_id:"7fab1e60-dfde-11f0-b610-85349516fd91",
    list:[
      { isAscShow:false, isArrow:null, name:'Bearing D1 温度', full_name: "电机轴承温度D1", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Bearing D2 温度', full_name: "电机轴承温度D2", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'D1 Vibration 震动', full_name: "透平机轴承振动D1", value:'-', unit:'ms'},
      { isAscShow:false, isArrow:null, name:'D2 Vibration 震动', full_name: "透平机轴承振动D2", value:'-', unit:'ms'},
      { isAscShow:false, isArrow:null, name:'Stator D1 温度', full_name: "电机定子温度D1", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Stator D2 温度', full_name: "电机定子温度D2", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Volute 温度', full_name: "透平机蜗壳温度", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Turbo 转速', full_name: "透平机转速", value:'-', unit:'rpm'},
      { isAscShow:false, isArrow:null, name:'电流', full_name: "运行功率", value:'-', unit:'kW'},
      { isAscShow:false, isArrow:null, name:'真空度', full_name: "透平机真空度", value:'-', unit:'kpa.g'},
    ],
  },
  //1st press
  {
    id:3,
    pos:'top:265px;left:670px',
    equip_id:"b01c64f0-dfde-11f0-b610-85349516fd91",
    list:[
      { isAscShow:false, isArrow:null, name:'车速', full_name: "车速", value:'-', unit:'m/min'},
      { isAscShow:false, isArrow:null, name:'纸种克重', full_name: "纸种克重", value:'-', unit:'g/m²'},
      { isAscShow:false, isArrow:null, name:'毛布使用情况', full_name: "毛布使用情况", value:'-', unit:'天'},
      { isAscShow:false, isArrow:null, name:'总脱水量', full_name: "总脱水量", value:'-', unit:'l/min'},
      { isAscShow:false, isArrow:null, name:'真空脱水量', full_name: "真空脱水量", value:'-', unit:'l/min'},
      { isAscShow:false, isArrow:null, name:'供油温度', full_name: "供油温度", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'供油压力', full_name: "供油压力", value:'-', unit:'Mpa'},
    ],
  },
  {
    id:4,
    pos:'bottom:38px;left:564px',
    equip_id:"b01c64f0-dfde-11f0-b610-85349516fd91",
    list:[
      { isAscShow:false, isArrow:null, name:'Bearing D1 温度', full_name: "电机轴承温度D1", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Bearing D2 温度', full_name: "电机轴承温度D2", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'D1 Vibration 震动', full_name: "透平机轴承振动D1", value:'-', unit:'ms'},
      { isAscShow:false, isArrow:null, name:'D2 Vibration 震动', full_name: "透平机轴承振动D2", value:'-', unit:'ms'},
      { isAscShow:false, isArrow:null, name:'Stator D1 温度', full_name: "电机定子温度D1", value:'-', unit:'℃'},
    ],
  },
  {
    id:5,
    pos:'bottom:38px;right:320px',
    equip_id:"b01c64f0-dfde-11f0-b610-85349516fd91",
    list:[
      { isAscShow:false, isArrow:null, name:'Stator D2 温度', full_name: "电机定子温度D2", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Volute 温度', full_name: "透平机蜗壳温度", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Turbo 转速', full_name: "透平机转速", value:'-', unit:'rpm'},
      { isAscShow:false, isArrow:null, name:'电流', full_name: "运行功率", value:'-', unit:'kW'},
      { isAscShow:false, isArrow:null, name:'真空度', full_name: "透平机真空度", value:'-', unit:'kpa.g'},
    ],
  },
  //3rd press
  {
    id:6,
    pos:'top:38px;left:1000px',
    equip_id:"4ffc20f0-dfdf-11f0-b610-85349516fd91",
    list:[
      { isAscShow:false, isArrow:null, name:'车速', full_name: "车速", value:'-', unit:'m/min'},
      { isAscShow:false, isArrow:null, name:'纸种克重', full_name: "纸种克重", value:'-', unit:'g/m²'},
      { isAscShow:false, isArrow:null, name:'毛布使用情况', full_name: "毛布使用情况", value:'-', unit:'天'},
      { isAscShow:false, isArrow:null, name:'总脱水量', full_name: "总脱水量", value:'-', unit:'l/min'},
      { isAscShow:false, isArrow:null, name:'真空脱水量', full_name: "真空脱水量", value:'-', unit:'l/min'},
      { isAscShow:false, isArrow:null, name:'供油温度', full_name: "供油温度", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'供油压力', full_name: "供油压力", value:'-', unit:'Mpa'},
    ],
  },
  {
    id:7,
    pos:'top:210px;left:1000px',
    equip_id:"4ffc20f0-dfdf-11f0-b610-85349516fd91",
    list:[
      { isAscShow:false, isArrow:null, name:'Bearing D1 温度', full_name: "电机轴承温度D1", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Bearing D2 温度', full_name: "电机轴承温度D2", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'D1 Vibration 震动', full_name: "透平机轴承振动D1", value:'-', unit:'ms'},
      { isAscShow:false, isArrow:null, name:'D2 Vibration 震动', full_name: "透平机轴承振动D2", value:'-', unit:'ms'},
      { isAscShow:false, isArrow:null, name:'Stator D1 温度', full_name: "电机定子温度D1", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Stator D2 温度', full_name: "电机定子温度D2", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Volute 温度', full_name: "透平机蜗壳温度", value:'-', unit:'℃'},
      { isAscShow:false, isArrow:null, name:'Turbo 转速', full_name: "透平机转速", value:'-', unit:'rpm'},
      { isAscShow:false, isArrow:null, name:'电流', full_name: "运行功率", value:'-', unit:'kW'},
      { isAscShow:false, isArrow:null, name:'真空度', full_name: "透平机真空度", value:'-', unit:'kpa.g'},
    ],
  },
]